import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRequestApprovalStatus = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/request-approval/status-progress/list' });

  return data;
};

export default getRequestApprovalStatus;
